import { render } from "./AdminAccountsView.vue?vue&type=template&id=bab4796c&scoped=true"
import script from "./AdminAccountsView.vue?vue&type=script&lang=js"
export * from "./AdminAccountsView.vue?vue&type=script&lang=js"

import "./AdminAccountsView.vue?vue&type=style&index=0&id=bab4796c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab4796c"]])

export default __exports__